var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNextSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,0C20.2,0,0,20.2,0,45s20.2,45,45,45s45-20.2,45-45S69.8,0,45,0z M45,80c-17.6,0-32.2-13.1-34.6-30h31.4l-9.1,9.1 l7.1,7.1L60.9,45L39.7,23.8l-7.1,7.1l9.1,9.1H10.4c2.4-16.9,17-30,34.6-30c19.3,0,35,15.7,35,35S64.3,80,45,80z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextSteps);
export default __webpack_public_path__ + "static/media/ic_next_steps.8f905f2202202da536a12f04cf817a78.svg";
export { ForwardRef as ReactComponent };